(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blom-product-card"] && !Shopify.designMode) return;
  try {
    /* .fg-img-2 is the hover image. It ships with no src and no srcset, so a touch device never
     downloads a picture it can never reveal. Pointer devices get it hydrated below. The CSS
     reveal rule is gated on [src], so with javascript off the card simply keeps showing its
     primary image and nothing breaks. */
  (function () {
    var mq = window.matchMedia('(hover: hover) and (pointer: fine)');
    var SEL = 'img.fg-img-2[data-fg-src]';

    function fill(img) {
      var ss = img.getAttribute('data-fg-srcset');
      if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-fg-srcset'); }
      img.setAttribute('src', img.getAttribute('data-fg-src'));
      img.removeAttribute('data-fg-src');
    }

    function scan(root) {
      if (!mq.matches || !root || !root.querySelectorAll) return;
      var list = root.querySelectorAll(SEL);
      for (var i = 0; i < list.length; i++) fill(list[i]);
    }

    function boot() {
      scan(document);
      if (window.MutationObserver) {
        new MutationObserver(function (muts) {
          if (!mq.matches) return;
          for (var m = 0; m < muts.length; m++) {
            var added = muts[m].addedNodes;
            for (var n = 0; n < added.length; n++) {
              var el = added[n];
              if (el.nodeType !== 1) continue;
              if (el.matches && el.matches(SEL)) fill(el); else scan(el);
            }
          }
        }).observe(document.body, { childList: true, subtree: true });
      }
      if (mq.addEventListener) mq.addEventListener('change', function () { scan(document); });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();
  } catch(e) { console.error(e); }
})();

})();
